import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';

import { loadingsOpenner, regPhone } from "../../utils/utils";

import * as APIS from "../../utils/service";

export default function Findid({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [inputArr, setinputArr] = useState([]);   
    const [resultData, setresultData] = useState('');   
    const [mbphone, setmbphone] = useState('');   
    const [errmsg, seterrmsg] = useState('');   

    useEffect(() => {

    }, []);

    const phoneInfoSumit = () => {
        if(mbphone === ''){
            seterrmsg('휴대폰 번호를 입력해주세요.');
            return false;
        }
        if(!regPhone.test(mbphone)) {
            seterrmsg('휴대폰 형식이 올바르지 않습니다.');
            return;
        }

        dispatch(loadingflas({ loading: true }));
        let sender = {
            hp: mbphone
        }
        APIS.postData('/v1/login/findid', sender).then(({ data }) => {
            console.log(data);
            if(data?.length > 0){
                setresultData(data[0]);
            } else {
                setresultData('no');
            }
            
        }).catch((e) => {
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
                
    }

    return(
        <Layout header={false}>
            <div className='normalform'>
                <div className='normalform_title'>아이디 찾기</div>
                <div className='normalform_comment'>가입시 인증하신 휴대전화번호를 입력하세요.</div>

                <div className='inputArea'>
                    <Input 
                        className={`inputs`}
                        placeholder="휴대폰 번호 입력"
                        setValue={setmbphone}
                        value={mbphone}
                        name="mb_phone"
                        withButton={'검색'}
                        withButtonPress={() => {
                            phoneInfoSumit();
                        }}
                        error={errmsg}
                        errClear={() => {
                            seterrmsg('');
                        }}
                        submitfunc={() => {
                            phoneInfoSumit();
                        }}

                    />                    
                </div>  
                      
                {resultData !== '' &&
                <>
                {resultData === 'no' ? 
                <div className='findidresultnoArea'>
                    가입된 정보가 없습니다.
                </div>                
                :
                <>
                <div className='findidresultArea'>
                    <div>
                        <p>가입일자</p>
                        <p>아이디</p>
                    </div>
                    <div>
                        <p>{moment(resultData?.create_dt).format('YYYY.MM.DD')}</p>
                        <p>{resultData?.email}</p>
                    </div>
                </div>                
                <div className='loginbutton'>
                    <Button
                        disabled={false}
                        buttonTxt={'로그인'}
                        onPress={() => {
                            navigate("/Login");
                        }}                           
                    />
                </div>
                </>
                }
                </>
                }
            </div>
        </Layout>
    )
}

